import { useState } from "react";
import { ScorePill } from "./ScorePill";

export function SessionHistory({ sessions }) {
  const [expandedId, setExpandedId] = useState(null);
  const sorted = [...sessions].reverse().slice(0, 15);

  return (
    <>
      <div className="session-row hdr"><span>Date</span><span>Type</span><span>Score</span><span>Time</span><span></span></div>
      {sorted.map((s) => {
        const isExpanded = expandedId === s.id;
        const mins = Math.floor(s.timeSec / 60), secs = s.timeSec % 60;
        const isMeaning = s.type === "meaning";
        const missed = s.missed || [];
        return (
          <div key={s.id}>
            <div className="session-row" style={{ cursor: "pointer" }} onClick={() => setExpandedId(isExpanded ? null : s.id)}>
              <span style={{ color: "var(--muted)", fontSize: ".82rem" }}>{new Date(s.date).toLocaleDateString("en-AU", { day:"numeric", month:"short", weekday:"short" })}</span>
              <span style={{ fontSize: ".75rem", color: isMeaning ? "var(--green)" : "var(--accent)", fontWeight: 700 }}>{isMeaning ? "Meaning" : "Spelling"}</span>
              <ScorePill pct={s.score} />
              <span style={{ color: "var(--muted)", fontSize: ".8rem" }}>{mins}m {secs}s</span>
              <span style={{ color: "var(--muted)", fontSize: ".8rem" }}>{isExpanded ? "▲" : "▼"}</span>
            </div>
            {isExpanded && (
              <div style={{ background: "var(--surface2)", borderRadius: 10, padding: ".75rem 1rem", marginBottom: ".35rem", fontSize: ".82rem" }}>
                <div style={{ fontWeight: 700, marginBottom: ".5rem", color: "var(--navy)" }}>
                  {s.total} words · {s.score}% · {mins}m {secs}s · +{s.ptsEarned || 0} pts
                </div>
                {missed.length > 0 && (
                  <div style={{ marginBottom: ".5rem" }}>
                    <div style={{ fontWeight: 700, color: "var(--red)", fontSize: ".75rem", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: ".3rem" }}>❌ Missed ({missed.length})</div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: ".3rem" }}>
                      {missed.map(w => <span key={w} style={{ background: "var(--red-light)", color: "var(--red)", padding: ".15rem .55rem", borderRadius: 999, fontWeight: 700 }}>{w}</span>)}
                    </div>
                  </div>
                )}
                {missed.length === 0 && (
                  <div style={{ color: "var(--green)", fontWeight: 700 }}>✅ Perfect score — all words correct!</div>
                )}
                {missed.length < s.total && missed.length > 0 && (
                  <div style={{ marginTop: ".4rem" }}>
                    <div style={{ fontWeight: 700, color: "var(--green)", fontSize: ".75rem", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: ".3rem" }}>✅ Correct ({s.total - missed.length})</div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: ".3rem" }}>
                      <span style={{ color: "var(--muted)", fontStyle: "italic" }}>{s.total - missed.length} word{s.total - missed.length !== 1 ? "s" : ""} correct</span>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}
